<template>
    <div style="position:relative;">
        <!-- >>> Treeview Container -->
        <div
            ref="treeviewcontainerref"
            class="treeviewcontainer">
            <!-- >>> Dragbar -->
            <div
                v-if="!$isSmallDesktop()"
                ref="dragbarref"
                class="dragbar"
                :class="{hover: hoverDragbar}"
                @mouseover="hoverDragbar = true"
                @mouseleave="hoverDragbar = false" />
            <!-- <<< Dragbar -->
            <!-- >>> Treeview Header -->
            <sdr-selected-flight-list-header
                v-if="modus !== 'slot'"
                style="position:sticky;z-index:2" />
            <sdr-selected-flight-list-header-slots
                v-else
                style="position:sticky;z-index:2" />
            <!-- <<< Treeview Header -->

            <!-- >>> Treeview -->
            <v-treeview
                v-model="selectedFlights"
                :items="flights"
                item-text="id"
                item-key="id"
                item-children="children"
                selection-type="leaf"
                return-object
                color="primary"
                transition
                selectable
                :open.sync="openIds">
                <template v-slot:label="{ item }">
                    <sdr-selected-flight-list-item
                        v-if="modus !== 'slot'"
                        style="padding-top: 7px;"
                        :layer="item.layer"
                        :item="item" />
                    <sdr-selected-flight-list-item-slots
                        v-else
                        style="padding-top: 7px;"
                        :layer="item.layer"
                        :item="item" />
                </template>
            </v-treeview>
            <!-- <<< Treeview -->
            <!-- >>> Dragbar -->
            <div
                v-if="$isSmallDesktop()"
                ref="dragbarref"
                class="dragbarBottom"
                :class="{hover: hoverDragbar}"
                @mouseover="hoverDragbar = true"
                @mouseleave="hoverDragbar = false" />
            <!-- <<< Dragbar -->
        </div>
        <!-- <<< Treeview Container -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import SelectedFlightListItem from './SelectedFlightListItem.vue';
    import SelectedFlightListItemSlots from './SelectedFlightListItemSlots.vue';
    import SelectedFlightListHeader from './SelectedFlightListHeader.vue';
    import SelectedFlightListHeaderSlots from './SelectedFlightListHeaderSlots.vue';
    import { eventBus } from '../../../../../main';



    export default {
        name: 'Selectedflightslist',
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-selected-flight-list-header': SelectedFlightListHeader,
            'sdr-selected-flight-list-header-slots': SelectedFlightListHeaderSlots,
            'sdr-selected-flight-list-item': SelectedFlightListItem,
            'sdr-selected-flight-list-item-slots': SelectedFlightListItemSlots

        },

        /* >>> *************************************************************** / /* Props */
        props: {
            flights: Array,
            selectedLayer: Number,
            modus: String
        }, // eof components{}
        /* <<< *****************************************************************



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                selectedFlights: [],
                openIds: [],
                // >>>>> Drag&Drop
                hoverDragbar: false,
                treeviewcontainerref: null,
                dragbarref: null,
                dragbarCurrentYPosition: 0
                // <<<<<
            };
        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_FlightTable_Rotations_Chain_Filtered'
            ])

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * selectedFlights()
            *
            * Desc: Treeview returns the lowest object in tree (the leg object)
            * Desc: Since the rotation object gives us nessecary details about
            * Desc: Slot relationships (VIA - TRIA etc.). we need to
            * Desc: collect single flights and regroup to rotation
            * Note: new Array in Rotation Object called "selectedChildren" gives
            * Note: us the partly / full selection of legs which belong to the rotation
            * Note: partly e.g. if I just select 1 Leg of a rotation consting of 2 Legs
            *
            */
            selectedFlights(value) {

                const me = this,
                    selectedRotations = [];
                let foundFlight = null,
                    legCount = 0;

                me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> watch >>> selectedFlights');
                if (me.selectedLayer === 1) {
                    me.flights.forEach(chain => {
                        chain.children.forEach(rotation => {
                            rotation.selectedChildren = [];
                            rotation.children.forEach(leg => {
                                legCount++;
                                foundFlight = value.find(v => v.id === leg.id);
                                if (foundFlight) {
                                    rotation.selectedChildren.push(leg);
                                }
                            });
                            if (rotation.selectedChildren.length > 0) {
                                selectedRotations.push(rotation);
                            }
                        });
                    });
                } else if (me.selectedLayer === 2) {
                    me.flights.forEach(rotation => {
                        rotation.selectedChildren = [];
                        rotation.children.forEach(leg => {
                            legCount++;
                            foundFlight = value.find(v => v.id === leg.id);
                            if (foundFlight) {
                                rotation.selectedChildren.push(leg);
                            }
                        });
                        if (rotation.selectedChildren.length > 0) {
                            selectedRotations.push(rotation);
                        }
                    });
                }
                eventBus.$emit('selectedlegcount', { selectedLegs: value.length, availableLegs: legCount });
                eventBus.$emit('rotationSelected', selectedRotations);

            } // eo function selectedFlights()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> created');
            eventBus.$on('selectallflightsfromheader', me.onEmit_selectAllFlights);
            me.openIds = [];


        }, // eo function created()



        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> mounted');
            me.onEmit_setDragAndDropListeners();
            me.onEmit_selectAllFlights(true);
            me.selectedFlights = me.flights;

        }, // eo function mounted()



        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> destroyed');
            eventBus.$off('selectallflightsfromheader', me.onEmit_selectAllFlights);

        }, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* methods */
        methods: {

            ...mapActions([
                'actn_call_getLegsInfo'
            ]),

            /*******************************************************************
            * onEmit_selectAllFlights()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_selectAllFlights: function (value) {

                const me = this,
                      flights = [];

                me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> onEmit_selectAllFlights');
                if (value) {
                    if (me.selectedLayer === 1) {
                        me.flights.forEach(chain => {
                            chain.children.forEach(rotation => {
                                rotation.children.forEach(leg => {
                                    flights.push(leg);
                                });
                            });
                        });
                    } else if (me.selectedLayer === 2) {
                        me.flights.forEach(rotation => {
                            rotation.children.forEach(leg => {
                                flights.push(leg);
                            });
                        });
                    }
                    me.selectedFlights = flights;
                } else {
                    me.selectedFlights = [];
                }
            }, // eo function onEmit_selectAllFlights()

            /*******************************************************************
            * onEmit_setDragAndDropListeners()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_setDragAndDropListeners: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> onEmit_setDragAndDropListeners');
                me.dragbarref = me.$refs.dragbarref;
                me.treeviewcontainerref = me.$refs.treeviewcontainerref;

                me.dragbarref.addEventListener('mousedown', function(e) {
                    me.dragbarCurrentYPosition = e.y;

                    document.addEventListener('mousemove', me.onEmit_resizeList, false);
                }, false);

                document.addEventListener('mouseup', function() {
                    // me.hoverDragbar = false;
                    document.removeEventListener('mousemove', me.onEmit_resizeList, false);
                }, false);

            }, // eo function onEmit_setDragAndDropListeners()


            /*******************************************************************
            * onEmit_resizeList()
            *
            * Desc: Calculates the new height of the Treeview Container
            * Note:
            *
            */
            onEmit_resizeList: function(e) {

                const me = this;
                const dragbarNewPosition =  e.y - me.dragbarCurrentYPosition;


                me.$toc('>>> views/flights/slotmanagement/components/shared/SelectedFlightsList.vue >>> onEmit_resizeList');
                if (e.preventDefault) {                      // prevent selection while draggin
                    e.preventDefault();
                }
                if (e.y < 50 || e.y > 650) {
                    return;
                }
                me.hoverDragbar = true;
                me.dragbarCurrentYPosition = e.y;
                if (Vue.prototype.$isSmallDesktop()) {
                    me.treeviewcontainerref.style.maxHeight = (parseInt(getComputedStyle(me.treeviewcontainerref, '').maxHeight) + dragbarNewPosition) + 'px';
                    me.treeviewcontainerref.style.height = (parseInt(getComputedStyle(me.treeviewcontainerref, '').height) + dragbarNewPosition) + 'px';
                } else {
                    me.treeviewcontainerref.style.maxHeight = (parseInt(getComputedStyle(me.treeviewcontainerref, '').maxHeight) - dragbarNewPosition) + 'px';
                    me.treeviewcontainerref.style.height = (parseInt(getComputedStyle(me.treeviewcontainerref, '').height) - dragbarNewPosition) + 'px';
                }

            } // eo function onEmit_resizeList()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
.v-treeview-node:nth-child(2n+1) {
    background: rgb(244, 244, 244);
}

.v-treeview > .v-treeview-node--leaf {
    padding-left: 0px !important;
    margin-left: 0px !important;
    /* border-bottom: 1px solid grey */
}

.v-treeview-node__children {
    background: white;;
}

.vdatatable_test >>> .v-treeview-node__root {
    border-bottom: 1px solid grey;
}
</style>

<style scoped>

.treeviewcontainer {
    top:0;
    overflow-y: auto;
    height: 200px;
}

.dragbar {
    position:absolute;
    top:0;
    width:100%;
    height:7px;
    z-index:4;
    background-color:#e3b6cf;
    text-align:center;
    cursor:ns-resize;
}
.dragbarBottom {
    position:absolute;
    bottom:0;
    width:100%;
    height:7px;
    z-index:4;
    background-color:#e3b6cf;
    text-align:center;
    cursor:ns-resize;
}

.hover {
    height: 13px;
}


</style>
